/**
 * Created by michaelbray on 2/23/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../sharedComponents/dropdown/Dropdown';
import * as Icons from '../sharedComponents/icons/Icons';
import { passValidations } from './passValidations';

const propTypes = {
    onChange: PropTypes.func
};

const placeholder = { label: "Select Pass", value: '' };
const dropdownItems = Object.keys(passValidations).map((k) => ({
    label: passValidations[k].label,
    value: k
}));
dropdownItems.unshift(placeholder);

export default class PassValidation extends React.Component {
    static doValidatePass(value, validation) {
        return new RegExp(validation).test(value.replace(/\s/g, ''));
    }

    constructor(props) {
        super(props);

        this.state = {
            displayForm: false,
            valid: undefined,
            passType: placeholder.value,
            passID: ''
        };

        this.handlePassIdChange = this.handlePassIdChange.bind(this);
        this.passTypeChange = this.passTypeChange.bind(this);
        this.showForm = this.showForm.bind(this);
        this.getFormElements = this.getFormElements.bind(this);
    }

    getFormElements() {
        if (this.state.displayForm) {
            return (
                <div className="rec-notification-wrap-sg-only">
                    <form id="validate-pass">
                        <div className="rec-nested-wrap">
                            <div className="rec-grid-5-12">
                                <div className="rec-form-item-wrap">
                                    <label htmlFor="passType">Pass</label>
                                    <Dropdown
                                        id="passType"
                                        options={dropdownItems}
                                        changeSelection={this.passTypeChange}
                                        currentSelection={this.state.passType} />
                                </div>
                            </div>
                            <div className="rec-grid-7-12">
                                <label htmlFor="passNumber">Pass ID</label>
                                <input
                                    type="text"
                                    id="passNumber"
                                    name="passNumber"
                                    maxLength={11}
                                    onChange={this.handlePassIdChange}
                                    value={this.state.passID} />
                            </div>
                        </div>
                    </form>
                    <hr />
                    <div className="rec-notification-info">
            <span className="rec-notification-icon">
              <Icons.IconInfo />
            </span>
                        <div className="rec-notification-body">
                            <div className="rec-notification-title-single-row">Attention Pass Holders</div>
                            <p>
                                The pass, a photo ID, and the reservation number must be presented when you pick up
                                your tickets at the facility. If you do not have one of these passes, you will have to
                                PAY IN FULL.
                            </p>
                            <img src={`${process.env.CDN}/img/pass/access_pass.jpg`} alt="Annual Pass" />
                            <img src={`${process.env.CDN}/img/pass/senior_annual_pass.jpg`} alt="Senior Pass" />
                            <img src={`${process.env.CDN}/img/pass/military_pass.jpg`} alt="Military Pass" />
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="buttons-wrap-sg-only">
                <button className="rec-button-link" title="Add Pass" aria-label="Add Pass" onClick={this.showForm}>
                    <Icons.IconAddCircle />
                    Add a Pass
                </button>
            </div>
        );
    }

    updateState(newState) {
        let prevValid;
        this.setState((prevState) => {
            prevValid = prevState.valid;
            return { ...prevState, ...newState };
        }, () => {
            if (prevValid !== newState.valid) {
                this.props.onChange(newState.valid);
            }
        });
    }

    showForm() {
        this.setState({ displayForm: true });
    }

    passTypeChange(selection) {
        const valid = selection !== placeholder.value
            ? PassValidation.doValidatePass(this.state.passID, passValidations[selection].regex)
            : false;

        this.updateState({ passType: selection, valid });
    }

    handlePassIdChange(event) {
        const passID = event.target.value !== ''
            ? event.target.value.replace(/\D/g, '').match(/\d{1,3}/g).join(' ')
            : '';
        const valid = this.state.passType !== placeholder.value
            ? PassValidation.doValidatePass(passID, passValidations[this.state.passType].regex)
            : false;

        this.updateState({ passID, valid });
    }

    render() {
        return (
            <div className="pass-valid-component sg-only-buttons">
                <h4>Passes</h4>
                {this.getFormElements()}
            </div>
        );
    }
}

PassValidation.propTypes = propTypes;
